import {
  Login,
  Register,
  ForgotPassword,
  ResetPassword,
} from "Pages";

//Index routes can't contain child routes.

//For using child routes, use Outlet in the parent component.

const PublicRoutes = [
  {
    component: <Login />,
    index: true,
  },
  {
    component: <Register />,
    path: "register",
  },
  {
    component: <ForgotPassword />,
    path: "forgot-password",
  },
  {
    component: <ResetPassword />,
    path: "reset-password/:token",
  },
  // {
  //   component: <Test />,
  //   path: "test",
  //   children: [
  //     {
  //       component: <Home />,
  //       path: "home",
  //       children: [{ component: <Login />, path: "about" }],
  //     },
  //     {
  //       component: <Login />,
  //       path: "about",
  //     },
  //   ],
  // },
];

export default PublicRoutes;
